import { render, staticRenderFns } from "./ProductGroupFilter.vue?vue&type=template&id=35619493&scoped=true&"
import script from "./ProductGroupFilter.vue?vue&type=script&lang=js&"
export * from "./ProductGroupFilter.vue?vue&type=script&lang=js&"
import style0 from "./ProductGroupFilter.vue?vue&type=style&index=0&id=35619493&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35619493",
  null
  
)

export default component.exports